import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Auth0Provider } from "@auth0/auth0-react";
import AuthenticationRequired from "middlewares/require-authentication";
import { AuthDomain, AuthClientId, AuthAudience } from "env-config";
import { ThemeProvider, Theme, StyledEngineProvider, createTheme } from "@mui/material/styles";


declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}


const theme = createTheme();

ReactDOM.render(
    <React.StrictMode>
        <Auth0Provider
            domain={AuthDomain()}
            clientId={AuthClientId()}
            redirectUri={window.location.origin}
            audience={AuthAudience()}
        >
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <AuthenticationRequired>
                        <App />
                    </AuthenticationRequired>
                </ThemeProvider>
            </StyledEngineProvider>
        </Auth0Provider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
